
export default function IconUser() {
  return (
    <svg
      id="fi_7820234"
      height="512"
      viewBox="0 0 60 60"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m49.919 59a4.077 4.077 0 0 0 3.869-5.36l-3.749-11.25a15.034 15.034 0 0 0 -1.08-2.46l-3.059-3.93a15.212 15.212 0 0 0 -10.28-4h-11.24a15.212 15.212 0 0 0 -10.28 4l-3.059 3.93a15.034 15.034 0 0 0 -1.08 2.46l-3.749 11.25a4.077 4.077 0 0 0 3.869 5.36z"
        fill="#f9c04e"
      ></path>
      <path
        d="m49.33 38.54-4.33 16.46v1h-30v-1l-4.33-16.46a2.025 2.025 0 0 1 1.96-2.54h34.74a2.025 2.025 0 0 1 1.96 2.54z"
        fill="#2d4056"
      ></path>
      <ellipse cx="30" cy="47" fill="#e4f4f4" rx="4" ry="3"></ellipse>
      <path
        d="m42 19v-6a12 12 0 0 0 -12-12 12 12 0 0 0 -12 12v6z"
        fill="#542e29"
      ></path>
      <path d="m34 29.68v2.32a4 4 0 0 1 -8 0v-2.32z" fill="#934c3b"></path>
      <path
        d="m39.6 21.4a12.888 12.888 0 0 1 -1.05 4.38c-1.15 2.273-6.036 5.22-8.55 5.22s-7.4-2.947-8.55-5.22a12.888 12.888 0 0 1 -1.05-4.38 2.4 2.4 0 0 1 0-4.8 3.458 3.458 0 0 1 3.111-3.46 12.936 12.936 0 0 0 5.955-2.372.938.938 0 0 1 1.068 0 12.914 12.914 0 0 0 5.99 2.374 3.438 3.438 0 0 1 3.076 3.458 2.4 2.4 0 0 1 0 4.8z"
        fill="#a85d48"
      ></path>
      <rect fill="#6e9099" height="4" rx="1" width="34" x="13" y="55"></rect>
    </svg>
  );
}
